import React from 'react'
import { ResponsiveContainer, LineChart, Line, Tooltip } from 'recharts'

interface TrendPoint {
  date: string
  cars: number
}

interface DealerTrendChartProps {
  data: TrendPoint[]
  color?: string
  height?: number
}

const CustomTooltip = ({ active, payload }: any) => {
  if (!active || !payload?.length) return null
  const point = payload[0].payload as TrendPoint
  return (
    <div
      style={{
        background: 'var(--color-bg-elevated)',
        border: '1px solid var(--color-border-default)',
        borderRadius: 6,
        padding: '6px 10px',
        fontSize: 11,
        color: 'var(--color-text-primary)',
        boxShadow: 'var(--shadow-md)',
      }}>
      <div style={{ color: 'var(--color-text-muted)', marginBottom: 2 }}>
        {point.date.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3')}
      </div>
      <div style={{ fontWeight: 600 }}>{point.cars.toLocaleString()} cars</div>
    </div>
  )
}

const DealerTrendChart: React.FC<DealerTrendChartProps> = ({ data, color = 'var(--color-accent-blue)', height = 32 }) => {
  if (!data || data.length < 2) return <span style={{ color: 'var(--color-text-disabled)', fontSize: 11 }}>--</span>

  const lastIdx = data.length - 1
  const prev = data[lastIdx - 1]?.cars ?? 0
  const curr = data[lastIdx]?.cars ?? 0
  const lineColor = curr < prev ? 'var(--color-error)' : curr > prev ? 'var(--color-success)' : color

  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={data}>
        <Line type="monotone" dataKey="cars" stroke={lineColor} strokeWidth={1.5} dot={false} isAnimationActive={false} />
        <Tooltip content={<CustomTooltip />} />
      </LineChart>
    </ResponsiveContainer>
  )
}

export default DealerTrendChart
